import React from 'react';
import {MappingType} from '../../redux/slices/MappingSlice';
import {ColumnObjectType} from '../global/CustomDataTable';
import {getColumn, getColumnWithArgs, getFilter, sortColumn} from './Global';
import {getGroupedItems} from '../../functions/functionLibrary';
import {FilterMatchMode, FilterOperator} from 'primereact/api';
import {LandRegister} from './GlobalData';

export interface ActionTracker {
    'dmt_es_id': string,
    'project_id': string,
    'vorgang_id': string,
    'status_id': number,
    'sachbearbeiter': any,
    'verhandler': any,
    'kommentare': any,
    'eigentuemer_anzahl': number,
    'eigentuemer_dmt_es_id': string,
    'nutzungsberechntigter_anzahl': any,
    'nutzungsberechntigter_dmt_es_id': any,
    'vertrag_erstellung': any,
    'vertrag_versand': any,
    'vertrag_uebergabe': any,
    'korrespondenz_fehlversuch': any,
    'korrespondenz_nachfrage': any,
    'korrespondenz_1verhandlung': any,
    'korrespondenz_2verhandlung': any,
    'korrespondenz_3verhandlung': any,
    'vertrag_unterzeichnet': any,
    'vertrag_verweigerung': any
}

export const getColumnsActionTracker = (t: any) => {
    const temp: any[] = [];

    temp.push(
        getColumnWithArgs(t, 'dmt_es_id', 'actionTracker:columns.', true, true),
        // getColumnWithArgs(t, 'project_id', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'status_id', 'actionTracker:columns.', true, true, {type: ColumnObjectType.StatusLights}),
        getColumnWithArgs(t, 'sachbearbeiter', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'verhandler', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'kommentare', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'eigentuemer_anzahl', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'eigentuemer_dmt_es_id', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'nutzungsberechntigter_anzahl', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'nutzungsberechntigter_dmt_es_id', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'vertrag_erstellung', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'vertrag_versand', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'vertrag_uebergabe', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'korrespondenz_fehlversuch', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'korrespondenz_nachfrage', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'korrespondenz_1verhandlung', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'korrespondenz_2verhandlung', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'korrespondenz_3verhandlung', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'vertrag_unterzeichnet', 'actionTracker:columns.', true, true),
        getColumnWithArgs(t, 'vertrag_verweigerung', 'actionTracker:columns.', true, true),
    );

    return temp;
};

export const getFiltersActionTracker = () => {
    return {
        ...getFilter('dmt_es_id'),
        // ...getFilter('project_id'),
        ...getFilter('status_id'),
        ...getFilter('sachbearbeiter'),
        ...getFilter('verhandler'),
        ...getFilter('kommentare'),
        ...getFilter('eigentuemer_anzahl'),
        ...getFilter('eigentuemer_dmt_es_id'),
        ...getFilter('nutzungsberechntigter_anzahl'),
        ...getFilter('nutzungsberechntigter_dmt_es_id'),
        ...getFilter('vertrag_erstellung'),
        ...getFilter('vertrag_versand'),
        ...getFilter('vertrag_uebergabe'),
        ...getFilter('korrespondenz_fehlversuch'),
        ...getFilter('korrespondenz_nachfrage'),
        ...getFilter('korrespondenz_1verhandlung'),
        ...getFilter('korrespondenz_2verhandlung'),
        ...getFilter('korrespondenz_3verhandlung'),
        ...getFilter('vertrag_unterzeichnet'),
        ...getFilter('vertrag_verweigerung'),
    };
};
